import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'generate-step',
  templateUrl: './generate-step.component.html'
})
export class GenerateStepComponent {
  @Input()
  public isLoading: boolean;

  @Input()
  public allUsed: boolean;

  @Output()
  public confirmRegenerate: EventEmitter<void>;

  @Output()
  public back: EventEmitter<void>;

  constructor() {
    this.back = new EventEmitter<void>();
    this.confirmRegenerate = new EventEmitter<void>();
  }
}
